import http from "@/utils/request";

const purchaseApi = {
  list: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  load: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.load",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  delete: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.delete",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  importPreview: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.importPreview",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  batchImport: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.batchImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  sendWms: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.sendWms",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  manualFinish: data =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.manualFinish",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default purchaseApi;
